module.exports = __webpack_public_path__ + "static/media/players.749c72b6.png";